import axios from "axios";
import { clearLocalStorageData, getLocalStorageData } from "../shared/commonFunction";
import { showToast } from "../shared/sharedComponents/ToasterMessage/ToasterMessage";

const BASE_URL = import.meta.env.VITE_API_URL;
const API_KEY = import.meta.env.VITE_API_KEY

// Create axios client
const apiClient = axios.create({
    baseURL: BASE_URL,
    timeout: 15000,
});

/**
 * Centralized error handler
 */
const handleApiError = (error) => {
    console.log('error: ', error);
    const status = error?.response?.status;
    const message = error?.response?.data?.message || "Something went wrong";

    switch (status) {
        case 400:
            showToast(message, "error");
            break;
        case 401:
            showToast(message, "error");
            clearLocalStorageData();
            setTimeout(() => {
                window.location.replace("/login");
            }, 800);
            break;
        case 403:
            showToast("Access denied.", "error");
            break;
        case 500:
            showToast(error?.response?.data?.error, "error");
            break;
        default:
            showToast(message, "error");
    }
    throw error;
};

/**
 * Generic DELETE API Request
 * @param {string} endpoint - API endpoint
 * @param {string|number|null} [id] - Optional resource ID
 * @param {object} [body={}] - Optional request body
 * @returns {Promise<any>}
 */
export const deleteApiRequest = async (endpoint, id = null, body = {}) => {
    try {
        const token = getLocalStorageData("token");

        const url = id ? `${endpoint}/${id}` : endpoint;
        const response = await apiClient.delete(url, {
            headers: {
                "Content-Type": "application/json",
                Authorization: token ? `Bearer ${token}` : "",
                "X-API-Key": API_KEY
            },
            data: body,
        });

        return response?.data;
    } catch (error) {
        handleApiError(error);
        return error;
    }
};
